import axios from "axios";
const axiosClient = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API + 'api/',
  headers: { "Content-Type": "application/json", Accept: "application/json" }
});

axiosClient.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${sessionStorage.getItem("authToken")}`;
  return config;
});

export default axiosClient;